// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"1c999d89","116":"43e7c52f","135":"492fe7bb","652":"21374e54","724":"d0617e24","854":"58cb2cda"}[chunkId] + ".chunk.css";
};